import type * as renameFolder from './renameFolder';
import { LazyModule, LazyAction } from 'owa-bundling';

export const lazyRenameFolder: LazyAction<
    typeof renameFolder.renameFolder,
    LazyModule<typeof renameFolder>
> = new LazyAction(
    new LazyModule<typeof renameFolder>(
        () => import(/* webpackChunkName: "RenameFolder" */ './renameFolder'),
        {
            name: 'RenameFolder',
        }
    ),
    m => m.renameFolder
);
